/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// utils
import InteractionUtils from "utils/interaction-utils/InteractionUtils.js";

// constants
const TAB_KEY = 9;

class FocusLock extends Component {
  constructor(props) {
    super(props);
    // @props: isLocked - Boolean

    this.ref = React.createRef(null);
    this.state = {
      eventSubscriberKey: null,
      focusableItems: [],
    };
  }

  render() {
    const { props, ref } = this;
    return (
      <div className={props.className || ""} style={props.style} ref={ref}>
        {props.children}
      </div>
    );
  }

  componentDidMount() {
    this.handleFocusableItem();
    const eventSubscriberKey = InteractionUtils.subscribe(
      "keydown",
      this.handleKeyPress
    );
    this.setState({ eventSubscriberKey });
  }

  componentDidUpdate() {
    this.handleFocusableItem();
  }

  componentWillUnmount() {
    const { state } = this;
    const { eventSubscriberKey } = state;
    InteractionUtils.unsubscribe(eventSubscriberKey);
  }

  handleFocusableItem = () => {
    const { ref, state } = this;
    const { focusableItems } = state;

    if (ref.current) {
      const newFocusableItems = ref.current.querySelectorAll(
        `button, [href], input, select, textarea, ` +
          `[tabindex]:not([tabindex="-1"]), video`
      );

      if (newFocusableItems.length !== focusableItems.length) {
        this.setState({ focusableItems: newFocusableItems });
      }
    }
  };

  handleKeyPress = (event) => {
    const { props, state } = this;
    const { isLocked } = props;
    const { focusableItems } = state;

    if (focusableItems.current) {
      const { keyCode, shiftKey } = event;
      const {
        length,
        0: firstItem,
        [length - 1]: lastItem,
      } = focusableItems.current;

      if (isLocked && keyCode === TAB_KEY) {
        // If focused on last item, focus first item
        if (!shiftKey && document.activeElement === lastItem) {
          event.preventDefault();
          firstItem.focus();
        }

        // If focused on first item, focus last item with shift + tab
        else if (shiftKey && document.activeElement === firstItem) {
          event.preventDefault();
          lastItem.focus();
        }
      }
    }
  };
}
export default FocusLock;
